const guiColors = {
    'color-scheme': 'dark',

    'ui-primary': '#0a0f1a',
    'ui-secondary': '#111827',
    'ui-tertiary': '#1f2937',

    'ui-modal-overlay': '#030617cc',
    'ui-modal-background': '#0a0f1a',
    'ui-modal-foreground': '#e5e7eb',
    'ui-modal-header-background': '#1b263b',
    'ui-modal-header-foreground': '#ffffff',

    'ui-white': '#0a0f1a',

    'ui-black-transparent': '#ffffff26',

    'text-primary': '#e5e7eb',

    'menu-bar-background': '#030617',
    'menu-bar-background-image': 'radial-gradient(circle at 20% 30%, rgba(70, 220, 160, 0.4) 0%, transparent 35%), radial-gradient(circle at 80% 70%, rgba(150, 90, 230, 0.5) 0%, transparent 40%), radial-gradient(circle at 45% 75%, rgba(240, 160, 180, 0.45) 0%, transparent 30%), radial-gradient(circle at 65% 25%, rgba(50, 200, 220, 0.35) 0%, transparent 45%), linear-gradient(145deg, #030617, #1b263b, #030617)',
    'menu-bar-foreground': '#ffffff',

    'assets-background': '#0a0f1a',

    'input-background': '#111827',

    'popover-background': '#111827',

    'badge-background': '#1b263b',
    'badge-border': '#374151',

    'fullscreen-background': '#030617',
    'fullscreen-accent': '#0a0f1a',

    'page-background': '#030617',
    'page-foreground': '#e5e7eb',

    'project-title-inactive': 'var(--ui-secondary)',
    'project-title-hover': '#ffffff3f',

    'link-color': '#60a5fa',

    'filter-icon-black': 'invert(100%)',
    'filter-icon-gray': 'grayscale(100%) brightness(1.7)',
    'filter-icon-white': 'brightness(0) invert(100%)',

    'paint-filter-icon-gray': 'brightness(1.7)'
};

const blockColors = {
    insertionMarker: '#9ca3af',
    workspace: '#111827',
    toolboxSelected: '#1f2937',
    toolboxText: '#d1d5db',
    toolbox: '#0a0f1a',
    flyout: '#0a0f1a',
    scrollbar: '#4b5563',
    valueReportBackground: '#111827',
    valueReportBorder: '#374151',
    valueReportForeground: '#e5e7eb',
    contextMenuBackground: '#0a0f1a',
    contextMenuBorder: '#ffffff26',
    contextMenuForeground: '#e5e7eb',
    contextMenuActiveBackground: '#1f2937',
    contextMenuDisabledForeground: '#6b7280',
    flyoutLabelColor: '#d1d5db',
    checkboxInactiveBackground: '#1f2937',
    checkboxInactiveBorder: '#9ca3af',
    buttonBorder: '#9ca3af',
    buttonActiveBackground: '#1f2937',
    buttonForeground: '#d1d5db',
    zoomIconFilter: 'invert(100%)',
    gridColor: '#374151'
};

export {
    guiColors,
    blockColors
};
